const Date = () => {
  return null;
}

export default Date;